if (!customElements.get('buy-more-save')) {
  class BuyMoreSave extends HTMLElement {
    constructor() {
      super();

      const dataEl = this.querySelector('[data-bms-product]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      this.tiers = Array.from(this.querySelectorAll('.bms__tier'));
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.bms__tier-radio');
        radio.addEventListener('change', this.onTierChange.bind(this));
      });

      this.querySelectorAll('.bms__unit-option').forEach((select) => {
        select.addEventListener('change', this.onOptionChange.bind(this));
      });

      this.querySelectorAll('.bms__unit').forEach((unit) => this.updateUnit(unit));

      const submit = this.querySelector('.bms__submit');
      if (submit) {
        submit.addEventListener('click', (event) => this.onSubmit(event, false));
      }

      const buyNow = this.querySelector('.bms__buynow');
      if (buyNow) {
        buyNow.addEventListener('click', (event) => this.onSubmit(event, true));
      }
    }

    onTierChange() {
      this.tiers.forEach((tier) => {
        const radio = tier.querySelector('.bms__tier-radio');
        const units = tier.querySelector('.bms__units');
        tier.classList.toggle('active', radio.checked);
        if (units) units.hidden = !radio.checked;
      });
    }

    onOptionChange(event) {
      const unit = event.target.closest('.bms__unit');
      if (unit) this.updateUnit(unit);
    }

    updateUnit(unit) {
      const selects = Array.from(unit.querySelectorAll('.bms__unit-option'));
      const selectedValues = selects.map((select) => select.value);

      const variant = this.variants.find((candidate) => {
        return selectedValues.every((value, index) => candidate[`option${index + 1}`] === value);
      });

      const input = unit.querySelector('.bms__unit-variant-id');
      const image = unit.querySelector('.bms__unit-thumb img');

      if (!variant) return;

      if (input) input.value = variant.id;

      if (image && variant.featured_image && variant.featured_image.src) {
        image.src = variant.featured_image.src;
      }
    }

    onSubmit(event, redirectToCheckout) {
      event.preventDefault();

      const activeTier = this.querySelector('.bms__tier.active');
      if (!activeTier) return;

      const items = Array.from(activeTier.querySelectorAll('.bms__unit'))
        .map((unit) => unit.querySelector('.bms__unit-variant-id').value)
        .filter(Boolean)
        .map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

      if (!items.length) return;

      const button = event.currentTarget;
      button.classList.add('loading');
      button.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (cart && !redirectToCheckout) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message);
          }

          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }

          if (cart) {
            cart.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              if (!elementToReplace || !response.sections || !response.sections[section.id]) return;
              const html = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
              const minicartForm = html.querySelector('#minicart-form');
              if (minicartForm) elementToReplace.innerHTML = minicartForm.innerHTML;
            });
            if (typeof cart.cartAction === 'function') cart.cartAction();
            if (typeof cart.open === 'function') cart.open();
          }

          fetch('/cart.js')
            .then((res) => res.json())
            .then((updatedCart) => {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${updatedCart.item_count})`;
                } else {
                  el.innerHTML = updatedCart.item_count > 100 ? '~' : updatedCart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(updatedCart);
              }
            });
        })
        .catch((error) => console.error(error))
        .finally(() => {
          if (redirectToCheckout) return;
          button.classList.remove('loading');
          button.disabled = false;
        });
    }
  }

  customElements.define('buy-more-save', BuyMoreSave);
}
